import React from "react";
import { bgMembershipBanner } from "assets";
import Tiers from "./Tiers";
import { BackgroundSection } from "../LandingPage/common";
import EmailSignUp from "../LandingPage/common/EmailSignUp";

const Header = () => {
  return (
    <>
      <BackgroundSection
        backgroundImage={`url(${bgMembershipBanner.default})`}
        maxHeight="550px"
        backgroundPosition="45%"
        className="relative h-screen bg-no-repeat bg-cover pt-20 px-4 mb-1 flex flex-col justify-end"
      >
        <div className="flex flex-col text-center text-white relative m-auto mt-24 sm:mt-32">
          <h1 className="text-2xl md:text-6xl font-semibold">Membership</h1>
          {/* <p className="text-lg text-wrap sm:w-3/4 self-center">
            Choose your perfect fit! We offer three membership tiers (FREE, PREMIUM, ALL ACCESS) to
            suit your eligibility and budget, available as monthly or annual subscriptions.
          </p> */}
        </div>
      </BackgroundSection>
      <div className="lg:w-9/12 xl:w-7/12 px-4 sm:mx-auto sm:pb-5">
        <div className="space-y-4 text-center">
          <p className="text-2lg -mt-10 pt-10 pb-5 lg:pt-12">
            Our <strong>Gig Life Pro Members Community</strong> is a <strong>curated network of over 2000 Global Members</strong>, across <strong>60 Cities Globally</strong>, representing over <strong>50 Roles in the Industry</strong> and with an <strong>average of 12+ yrs of Experience.</strong>
          </p>

        </div>
      </div>
    </>
  );
};

const Membership = () => {
  return (
    <div className="w-screen flex flex-col">
      <Header />
      <Tiers />
      {/* <EmailSignUp /> */}
    </div>
  );
};

export default Membership;
